<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :return-value.sync="lazyValue"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="timeValue"
        prepend-inner-icon="mdi-clock"
        readonly
        v-bind="$attrs"
        clearable
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      color="primary" format="24hr"
      v-model="lazyValue"
      no-title
      scrollable
      @change="onTimeChange"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
      <v-btn text color="primary" @click="onSaveClick"> OK </v-btn>
    </v-time-picker>
  </v-menu>
</template>

<script>
import moment from "moment";

export default {
  name: "MenuTimepicker",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: null,
  },
  data() {
    return {
      menu: false,
      lazyValue: this.value,
    };
  },
  methods: {
    onSaveClick() {
        this.$emit("change", this.lazyValue);
        this.$refs.menu.save(this.lazyValue);
    },
    onTimeChange() {
        this.$emit("change", this.lazyValue);
        this.$refs.menu.save(this.lazyValue);
    },
  },
  computed: {
    timeValue: {
      get() {
        if (!this.lazyValue) return "";
        return this.lazyValue.substring(0, 5);
      },
      set(value) {
        this.lazyValue = value;
        this.$emit("change", this.lazyValue);
        this.$refs.menu.save(this.lazyValue);
      },
    },
  },
};
</script>

<style scoped></style>
